<template>
    <home endpoint="fee" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'fee',
  components: {
    home,
  },
  data  () {
    return {
      params: {
        fields: [
          {name: 'FeeCode', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'Description', label: 'Descripción', required: true},
          {name: 'FeeClass', label: 'Clase', editor: 'select', required: true, defValue: 0,
              options: [
                    {value: 0, label: 'PASSENGER'},
                    {value: 1, label: 'SEGMENT'},
                    {value: 2, label: 'BOOKING'},
                    ]},
          {name: 'Lid', label: 'Max. Por Vuelo', editor: 'number'},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'},
          {name: 'Amounts', editor: [], hideFromList: true, label: 'Precios',
            rowFields: [
                {name: 'MarketType', label: 'Mercado', editor: 'select', required: true, defValue: 0,
                    columns: 2,
                    options: [
                        {value: 0, label: 'Local'},
                        {value: 1, label: 'Internacional'},
                    ]},
                {name: 'Currency', relation: 'currency', optionLabels: 'id',
                    editor: 'select', label: 'Moneda', required: true, defValue: 'ARS', columns: 2},
                {name: 'Amount', label: 'Monto', editor: 'number', required: true, columns: 2},
                {name: 'EffectiveDate', label: 'Vigente desde', editor: 'date', required: true, columns: 3},
                {name: 'IsActive', label: 'Activo', editor: 'checkbox', defValue: true, columns: 2},
            ]},
          ],
        title: 'Cargos',
        title2: 'Cargo',
        primaryKey: 'FeeCode',
        modalClass: 'modal-large',
      }
    }
  },
}
</script>
